import React, { useContext, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import { Schema } from "src/modules/flow-designer/vts/select-tables-modal/schema-table";
import ValidateSchemaView from "src/modules/flow-designer/vts/select-tables-modal/components/validate-schema-view/validate-schema-view";
import SelectTablesProvider from "src/modules/flow-designer/vts/select-tables-context";
import { getSchemaTypeFromDBType } from "src/modules/flow-designer/vts/selectTables-utils";

import { wizardcontext } from "../../../source-configurator-tool";
import { StepProps } from "../../source-configurator.types";
import SidebarStepFooter from "../../sidebar-step-footer";

const ValidateTablesPage = ({ onNext, onBack, onCancel }: StepProps) => {
    const { selectedSchemas, schemas, connectionParams, sourceType, setState } = useContext(wizardcontext);

    const [apiStatus, setApiStatus] = useState({
        isAPISuccessful: false,
        isAPICompleted: false,
        canRetry: false
    });

    const cancelRef = useRef(false);
    const childRef = useRef(null);
    const schemaTablesList = useRef<Schema[]>(selectedSchemas as Schema[]);

    const schemaType = getSchemaTypeFromDBType(sourceType ?? "");

    const handleSetSelectedSchemaTables = (updatedSchemas: Schema[]) => {
        setState((prev: any) => ({
            ...prev,
            selectedSchemas: updatedSchemas
        }));
    };

    const handleBack = () => {
        cancelRef.current = true;
        onBack?.();
    };

    useEffect(() => {
        if (apiStatus.isAPISuccessful) {
            setTimeout(() => {
                onNext();
            }, 500);
        }
    }, [apiStatus]);
    const normalisedFormValues = Object.fromEntries(
        Object.entries(connectionParams).map(([key, value]) => [key.toLowerCase(), value])
    );
    return (
        <SelectTablesProvider>
            <Box sx={{ width: "100%" }}>
                <ValidateSchemaView
                    adapterName={null}
                    selectedSchemaTables={selectedSchemas as Schema[]}
                    setSelectedSchemaTables={handleSetSelectedSchemaTables}
                    selectedSchemaTableColumns={schemas as Schema[]}
                    isEditFlow={false}
                    formValues={normalisedFormValues}
                    dbType={sourceType ?? ""}
                    schemaTablesList={schemaTablesList}
                    setApiStatus={setApiStatus}
                    childRef={childRef}
                    metaObjectId={null}
                    schemaType={schemaType}
                    cancelRef={cancelRef}
                />

                <SidebarStepFooter
                    onCancel={onCancel}
                    onBack={handleBack}
                    onNext={onNext}
                    nextDisabled={!apiStatus.isAPICompleted || apiStatus.canRetry}
                    backDisabled={!apiStatus.isAPICompleted}
                    nextLabel={apiStatus.canRetry ? "Retry" : "Next"}
                />
            </Box>
        </SelectTablesProvider>
    );
};

export default ValidateTablesPage;
